import React, { ReactNode, RefObject } from 'react'
import { Box } from '@mui/material'

interface WidgetContentWrapperProps {
  children: ReactNode
  innerRef?: RefObject<HTMLDivElement>
}

const WidgetContentWrapper = (props: WidgetContentWrapperProps) => {
  return (
    <div ref={props.innerRef}>
      <Box
        sx={theme => ({
          padding: theme.spacing(3, 4.5, 5),
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 3, 3.5),
          },
        })}
      >
        {props.children}
      </Box>
    </div>
  )
}

export default WidgetContentWrapper
